var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "change" }, [
    _c("header", [
      _c("div", { staticClass: "inner" }, [
        _c("div", { staticClass: "mm_logo" }, [
          _c("a", { attrs: { href: "/" } }, [
            _c("picture", [
              _c("source", {
                attrs: {
                  srcset: _vm.getImage("header/tategulogo_wh.png"),
                  type: "image/png",
                  media: "(min-width: 700px)"
                }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src: _vm.getImage("header/tategulogo_wh.png"),
                  type: "image/png",
                  alt: "SKETCH ORDER"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "powered" }, [
            _vm._v("powered by Domans, inc.")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "so_logo" }, [
          _c("a", { attrs: { href: "/" } }, [
            _c("picture", [
              _c("source", {
                attrs: {
                  srcset: _vm.getImage("header/so_logo_header_w_kana.png"),
                  type: "image/png",
                  media: "(min-width: 700px)"
                }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src: _vm.getImage("header/so_logo_header_w_kana.png"),
                  type: "image/png",
                  alt: "SKETCH ORDER"
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "btn_menu" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shadow" })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("nav", [
      _c("ul", [
        _c("li", { staticClass: "header_nav_item" }),
        _vm._v(" "),
        _c("li", { staticClass: "header_nav_item" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a1a3e8d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a1a3e8d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/components/Header.vue
// module id = null
// module chunks = 